import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "ma_cookie_consent";

const CookieBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(STORAGE_KEY)) {
            const t = setTimeout(() => setVisible(true), 1500);
            return () => clearTimeout(t);
        }
    }, []);

    const choose = (value) => {
        localStorage.setItem(STORAGE_KEY, value);
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ opacity: 0, y: 60 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 60 }}
                    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed inset-x-4 bottom-4 z-[60] mx-auto max-w-2xl sm:bottom-6"
                    role="dialog"
                    aria-label="Aviso de cookies"
                    data-testid="cookie-banner"
                >
                    <div className="rounded-3xl border border-lilac/50 bg-white/70 p-5 shadow-2xl shadow-plum/20 backdrop-blur-xl sm:p-6">
                        <div className="flex items-start gap-4">
                            <span className="hidden h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-lilac to-serenity text-white sm:flex">
                                <Cookie size={20} />
                            </span>
                            <div className="flex-1">
                                <p className="font-serif text-lg font-semibold text-plum">Este site usa cookies</p>
                                <p className="mt-1 text-sm leading-relaxed text-ink">
                                    Utilizamos cookies para melhorar sua experiência e entender a navegação. Ao aceitar, você concorda com nossa{" "}
                                    <Link to="/privacidade" data-testid="cookie-policy-link" className="font-semibold text-serenity underline underline-offset-2 hover:text-plum">
                                        Política de Privacidade
                                    </Link>
                                    .
                                </p>
                                <div className="mt-4 flex flex-col gap-2.5 sm:flex-row">
                                    <button
                                        onClick={() => choose("accepted")}
                                        data-testid="cookie-accept-button"
                                        className="inline-flex min-h-[48px] flex-1 items-center justify-center rounded-full bg-gradient-to-r from-lilac via-serenity to-serenitylight px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-serenity/30 transition-transform duration-300 hover:scale-[1.03]"
                                    >
                                        Aceitar cookies
                                    </button>
                                    <button
                                        onClick={() => choose("declined")}
                                        data-testid="cookie-decline-button"
                                        className="inline-flex min-h-[48px] flex-1 items-center justify-center rounded-full border border-lilac/60 bg-white/60 px-6 py-3 text-sm font-semibold text-plum transition-colors duration-300 hover:bg-lav/50"
                                    >
                                        Apenas essenciais
                                    </button>
                                </div>
                            </div>
                            <button onClick={() => choose("declined")} aria-label="Fechar aviso de cookies" data-testid="cookie-close-button" className="shrink-0 rounded-full p-1.5 text-ink/50 transition-colors hover:text-plum">
                                <X size={18} />
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CookieBanner;
